<template>
  <v-card
    class="fill-height pa-2 pa-md-6 card"
    tile
  >
    <v-card-title>
      <div>
        <router-link class="card-heading break-normal" :to="`posts/${post.id}`">
          <h2>{{ post.heading }}</h2>
        </router-link>
        <span
          v-if="post.tribe"
          class="chip"
        >
          {{ post.tribe.name }}
        </span>
        <span class="chip" v-if="post.hours">
            | {{ post.hours }}
          </span>
        <span class="chip" v-if="post.permanency">
            | {{ post.permanency }}
          </span>
      </div>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text
      class="grow"
    >

        <v-row
          class="py-2"
        >
          <v-col
            cols="12"
          >
            <template
              v-if="post.selling_point_1 || post.selling_point_2 || post.selling_point_3">
              <ul class="bullet-points mb-6">
                <li v-if="post.selling_point_1">{{ post.selling_point_1 }}</li>
                <li v-if="post.selling_point_2">{{ post.selling_point_2 }}</li>
                <li v-if="post.selling_point_3">{{ post.selling_point_3 }}</li>
              </ul>
            </template>
            <template v-if="post.show_salary && post.salary_from && post.salary_to">
              {{ $t('Estimated Pay: ')}} {{ post.salary_from }} - {{ post.salary_to }}
            </template>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
          >
            <div
              class="summary"
              v-html="post.job_summary"
            >

            </div>
          </v-col>
        </v-row>


    </v-card-text>
    <v-card-actions>
      <v-row
        class="py-2 mt-2 px-2"
      >
        <v-col
          cols="12"
        >
          <template v-if="post.tribe">
            <strong><span class="primary--text">{{ post.tribe.name }}</span></strong><br>
            {{ post.tribe.address_1 }}<br>
            <span v-if="post.tribe.address_2">
              {{ post.tribe.address_2 }}<br>
            </span>
            {{ post.tribe.locality }}<span v-if="post.tribe.state">, {{ post.tribe.state }} {{ post.tribe.postal_code }}</span>
          </template>
        </v-col>
        <v-col
          cols="12"
        >
          <primary-button
            :to="`posts/${post.id}`"
          >
            View Details
          </primary-button>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
  .card {
    display: flex;
    flex-direction: column;
  }

  .card-heading {
    text-decoration: none;
    color: #444140;
  }

  .chip {
    color: #D2302F;
    font-size: 15px;
  }

  .bullet-points {
    font-size: 20px;
    line-height: 30px;
    font-weight: 600;
    color: #444140;
  }

  .summary {
    font-size: 17px;
    line-height: 25px;
    color: #444140;
  }

  .card-height {
    height: calc(100% - 273px);
  }
</style>

<script>
  export default {
    name: 'PostCard',
    props: {
      post: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {};
    },
  };
</script>

